module.exports = __webpack_public_path__ + "img/3.f51dfd28.svg";